import React from "react";
import "../style.css";

export const Footer = () => {
    const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-grid">

        {/* About */}
        <div className="footer-about">
          <h3 title="Mahakaleshwar Aashram">🌼 श्री महाकालेश्वर ज्ञान मंदिर आश्रम</h3>
          <p>
            पूज्य स्वामी ब्रह्मानंद सरस्वती जी महाराज द्वारा स्थापित यह आश्रम
            भारतीय संस्कृति, वेद, योग, तंत्र, ध्यान और गौ-सेवा के माध्यम से
            मानवता के कल्याण के लिए समर्पित है। यहाँ जीवन का उद्देश्य
            ईश्वर-प्राप्ति, आत्म-जागरण और विश्व-शांति की दिशा में साधना करना है।
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>🔗 त्वरित लिंक</h4>
          <ul>
            <li><a href="#jeevan-parichay">जीवन परिचय</a></li>
            <li><a href="#donation">सेवा / दान</a></li>
            <li><a href="#gallery">गैलरी</a></li>
            <li><a href="#contact">संपर्क करें</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-social">
          <h4>🌐 सोशल मीडिया</h4>
          <div className="social-icons">
            <a title="Swami Bramhanand Saraswati" href="https://www.facebook.com/profile.php?id=61585870640010" target="_blank" aria-label="Facebook" className="social fb">
              <img src="https://img.icons8.com/color/1200/facebook-new.jpg" style={{width:"40px"}}/>
            </a>
            <a href="https://instagram.com" target="_blank" aria-label="Instagram" className="social ig">
              <img src="https://img.icons8.com/color/1200/instagram-new.jpg" style={{width:"40px"}}/>
            </a>
            <a title="Swami Bramhanand Saraswati" href="https://www.youtube.com/@Swami-Brahmanand-Saraswati" target="_blank" aria-label="YouTube" className="social yt">
              <img src="https://img.icons8.com/color/1200/youtube-play.jpg" style={{width:"40px"}}/>
            </a>
            <a href="https://twitter.com" target="_blank" aria-label="Twitter" className="social tw">
              <img src="https://img.icons8.com/color/1200/twitterx--v1.jpg" style={{width:"40px"}}/>
            </a>
            <a href="mailto:info@mahakalashram.org" aria-label="Email" className="social em">
              <img src="https://img.icons8.com/color/1200/share--v1.jpg" style={{width:"40px"}}/>
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {year} श्री गुरु स्वामी ब्रह्मानंद सरस्वती जी महाराज | सर्वाधिकार सुरक्षित</p>
      </div>
    </footer>
  );
};
